<template>
  <div>
    <base-fieldset>
      <base-input v-model.trim="name" size="sm" label="name" clearable />
    </base-fieldset>
    <base-fieldset>
      <base-input v-model.trim="customerAccount" size="sm" label="customer_account" clearable />
    </base-fieldset>
    <base-fieldset>
      <label class="text-xs font-semibold">{{ $t(`mygwf.components.Label.company_name`) }}</label>
      <div class="relative my-3 space-y-5 text-sm flex flex-col">
        <base-radio
          v-for="entry in typeOptions"
          :key="entry.label"
          :value="entry.value"
          :label="entry.label"
          name="type"
          v-model="is_distributor"
        />
      </div>
    </base-fieldset>
    <base-fieldset>
      <label class="text-xs font-semibold">{{ $t(`mygwf.components.Label.status`) }}</label>
      <div class="relative my-3 space-y-5 text-sm flex flex-col">
        <base-radio
          v-for="type in statusOptions"
          :key="type.label"
          :value="type.value"
          :label="type.label"
          name="status"
          v-model="is_active"
        />
      </div>
    </base-fieldset>
    <base-fieldset>
      <label class="text-xs font-semibold">{{ $t(`mygwf.components.Label.distributed_by`) }}</label>
      <div class="relative my-3 space-y-5 text-sm flex flex-col">
        <base-select
          v-model="distributor"
          class="width-limit"
          :options="companies.filter(company => company.is_distributor)"
          :optionType="{id: 'id', label: 'name'}"
          allowClear
          searchable
          size="sm"
        />
      </div>
    </base-fieldset>
  </div>
</template>

<script>
import {
  BaseSelect,
  BaseInput,
  BaseIcon,
  BaseButton,
  BaseFieldset,
  BaseRadio,
} from '@/components/base'
import CompanySelect from '@/components/shared/CompanySelect.vue'
import 'ant-design-vue/lib/popover/style/index.css'
import _isEmpty from 'lodash-es/isEmpty'

export default {
  components: {
    BaseSelect,
    BaseRadio,
    BaseInput,
    BaseIcon,
    BaseFieldset,
    BaseButton,
    CompanySelect,
  },

  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      name: this.$route.query.name || '',
      is_distributor: this.$route.query.is_distributor || '',
      is_active: this.$route.query.is_active || '',
      distributor: parseInt(this.$route.query.distributor, 10) || undefined,
      customerAccount: this.$route.query.customer_account || '',
      typeOptions: [
        {label: 'all', value: ''},
        {label: 'distributor', value: 'true'},
        {label: 'customer', value: 'false'},
      ],
      statusOptions: [
        {label: 'all', value: ''},
        {label: 'active', value: 'true'},
        {label: 'inactive', value: 'false'},
      ],
    }
  },

  computed: {
    companies() {
      return this.$store.getters['companies/list']
    },
  },

  watch: {
    $route(n, o) {
      if (_isEmpty(n.query)) {
        this.reset()
      }
    },
    name(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'name'})
    },
    is_distributor(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'is_distributor'})
    },
    is_active(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'is_active'})
    },
    distributor(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'distributor'})
    },
    customerAccount(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'customer_account'})
    },
  },

  methods: {
    submit() {
      let filters = {
        value: [
          this.name,
          this.is_distributor,
          this.is_active,
          this.distributor,
          this.customerAccount,
        ],
        name: ['name', 'is_distributor', 'is_active', 'distributor', 'customer_account'],
      }
      this.$store.dispatch('app/filterProp', filters)
    },

    reset() {
      this.name = ''
      this.is_distributor = ''
      this.is_active = ''
      this.distributor = undefined
      this.customerAccount = ''
      this.$router.push({name: 'Companies', query: {}})
    },
  },
}
</script>

<style></style>
